import axios from "axios";
import { DateTime } from "luxon";
import Links from "@/models/Links"

const state = {
    holidays: [],
    weekEndDays: [],
    temporaryDay: "",
};

const getters = {
    getHolidays(state) {
        return state.holidays;
    },
    getWeekEndDays(state) {
        return state.weekEndDays;
    },
};

const mutations = {
    SET_HOLIDAYS: (state, data) => (state.holidays = data),
    SET_WEEKENDDAYS: (state, data) => (state.weekEndDays = data),
    FORMAT_DATE : (state, data) => ( state.temporaryDay = data.getFullYear() + "-" + ("0" + (data.getMonth() + 1)).slice(-2) + "-" + ("0" + data.getDate()).slice(-2)),
};

const actions = {
    
    async getHolidays({commit}) {
        await axios
            .get(Links.CalendarGetHolidays)
            .then((resp) => { commit("SET_HOLIDAYS", Object.keys(resp.data));});
    },

    getWeekEndDays({commit}) {
        let tableOfWeekEnds = [];
        let todayYear = new Date().getFullYear();
        let startYear = todayYear - 2;

        for (let i = 0; i < 5; i++) {
            let dayOfWeek = new Date(startYear, 0, 1).getUTCDay();
            let numberOfDaysInYear =
                (startYear % 4 === 0 && startYear % 100 > 0) || startYear % 400 == 0 ? 366 : 365;

            let dateOfFirstDay = new Date(startYear, 0, 1);
            let temporaryDay = new Date(startYear, 0, 1);

            for (let j = 0; j <= numberOfDaysInYear; j++) {
                if (dayOfWeek == 5) {
                    temporaryDay.setDate(dateOfFirstDay.getDate() + j);
                    commit("FORMAT_DATE", temporaryDay)
                    tableOfWeekEnds.push(state.temporaryDay);
                    temporaryDay.setFullYear(startYear, 0, 1);
                }

                if (dayOfWeek == 6) {
                    temporaryDay.setDate(dateOfFirstDay.getDate() + j);
                    commit("FORMAT_DATE", temporaryDay)
                    tableOfWeekEnds.push(state.temporaryDay);
                    temporaryDay.setFullYear(startYear, 0, 1);
                    dayOfWeek = -1;
                }
                dayOfWeek++;
            }
            startYear = startYear + 1;
        }
        commit("SET_WEEKENDDAYS", tableOfWeekEnds);
    },  
};


const methods = {
    /**
     * checks if the date is a week end day
     * @param {string} a string of the date date to check 
     * @returns {boolean} true if it is a week end day, false if it is not
     */
    isWeekEndDay(date) {
        if (state.weekEndDays.includes(date)) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * checks if the date is a holiday
     * @param {string} date date to check 
     * @returns {boolean} true if it is a holiday, false if it is not
     */
    isHoliDay(date) {
        if(state.holidays.includes(date)){
            return true;
        }else{
            return false;
        }
    },
    // /**
    //  * check's if a duration interval of an event contains a week end day 
    //  * @param {Object} intervention event we want to test
    //  * @param {string} startDate start date of event
    //  * @returns true if there is a Week End day in the time interval of the event
    //  */
    // isThereWeekEndDay(intervention, startDate) {
    //     let startDateTime = new Date(startDate);

    //     for (let i = 0; i < intervention.duration; i++) {
    //         if (state.weekEndDays.includes(this.formatDate(startDateTime))) {
    //             return true;
    //         }
    //         startDateTime.setDate(startDateTime.getDate() + 1);
    //     }

    //     return false;
    // },
    // /**
    //  * check's if an interval of time contains a week end day
    //  * @param {string} startDate start date of interval to test
    //  * @param {string} endDate end of the interval to test
    //  * @returns true if there is a Week End day in the time interval
    //  */
    // isThereWeekEndDayStartEnd(startDate, endDate){
    //     let startDateTime = new Date(startDate);
    //     let endDateTime = new Date(endDate);
    //     const duration = endDateTime.getDate() - startDateTime.getDate();

    //     for (let i = 0; i < duration; i++) {
    //         if (state.weekEndDays.includes(this.formatDate(startDateTime))) {
    //             return true;
    //         }
    //         startDateTime.setDate(startDateTime.getDate() + 1);
    //     }
    // },
    // /**
    //  * check's if a duration interval of an event contains a holiday 
    //  * @param {Object} intervention event we want to test
    //  * @param {string} startDate start date of event
    //  * @returns true if there is a holiday in the time interval of the intervention
    //  */
    // isThereHoliday(startDate, intervention){
    //     let startDateTime = new Date(startDate);

    //     for (let i = 0; i < intervention.duration; i++) {
    //         if (state.holidays.includes(this.formatDate(startDateTime))) {
    //             return true;
    //         }
    //         startDateTime.setDate(startDateTime.getDate() + 1);
    //     }
    // },
    // /** check's if an interval of time contains a holiday
    //  * @param {string} startDate start date of interval to test
    //  * @param {string} endDate end of the interval to test
    //  * @returns true if there is a holiday in the time interval
    // */
    // isThereHolidayStartEnd(startDate, endDate){
    //     let startDateTime = new Date(startDate);
    //     let endDateTime = new Date(endDate);
    //     const duration = endDateTime.getDate() - startDateTime.getDate();

    //     console.log(duration);
    //     for (let i = 0; i < duration; i++) {
    //         if (state.holidays.includes(this.formatDate(startDateTime))) {
    //             return true;
    //         }
    //         startDateTime.setDate(startDateTime.getDate() + 1);
    //     }
    // },
    /**
     * Formats a Date element into a string representing the date
     * @param {Date} date 
     * @returns {string} a date formated as : YYYY-MM-dd
     */
    formatDate(date) {
        return (
            date.getFullYear() +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + date.getDate()).slice(-2)
        );
    },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  methods,
};
